null


// WEBPACK FOOTER //
// /Volumes/brazil-workspaces/Phoenix/PITLambda/src/vendor/dom-utils/get-attributes.ts